import type { StoryObj } from '@storybook/html'
import { ICONS } from '@pollux-docaposte/icon-library'
import { COLORS } from '@pollux-docaposte/core-design-system/dist/core-design-system/tokens/colors'
import { SIZEICON } from '../../tokens/numbers/size/icon'
import type { CobaltIcon } from './cobalt-icon'

const iconsAvailable = Object.keys(ICONS)
const colorsAvailable = Object.keys(COLORS)
// adding default value to the list
colorsAvailable.push('currentcolor')
const sizeAvailable = Object.keys(SIZEICON)
// adding default value to the list
sizeAvailable.push('100%')

export default {
  title: 'Components/Assets/cobalt-icon',
  argTypes: {
    name: {
      type: { name: 'string', required: true },
      options: iconsAvailable,
      control: { type: 'select' },
      description: 'Accept all icon names from `@pollux-docaposte/icon-library`. Check icons available in the control column.',
      table: {
        type: { summary: `${JSON.stringify(iconsAvailable).substring(0, 100)}...` }
      }
    },
    fill: {
      control: 'select',
      options: colorsAvailable,
      description: 'Taking the `currentcolor` (inherited color of the font) by default except if specified.',
      table: {
        type: { summary: 'text' },
        defaultValue: { summary: 'currentcolor' }
      }
    },
    size: {
      options: sizeAvailable,
      control: { type: 'select' },
      description: 'Taking the size of the parent element by default except if specified.',
      table: {
        type: { summary: 'text' },
        defaultValue: { summary: '100%' }
      }
    }
  }
}

const Template = (args: CobaltIcon) => {
  return `<div style="width: 60px"><cobalt-icon name="${args.name}" fill="${args.fill}" size="${args.size}"></cobalt-icon></div>`
}

export const Default: StoryObj = Template.bind({})

Default.args = {
  name: iconsAvailable[0],
  fill: 'currentcolor',
  size: '100%'
}
